<script>
    import { fade }   from 'svelte/transition'
    import * as api   from '../../shared/api.js'
    import Modal      from '../../shared/Modal.svelte'
    import FileUpload from '../../shared/FileUpload.svelte'

    export let domain     = null
    export let email      = null
    export let display    = false
    export let activities = []
    export let selected   = []
           let fileData   = null
           let working    = false
           let error      = null

    function cancel() {
        display  = false
        selected = []
    }

    function fileReady(evt) {
        fileData = evt.detail
    }

    function confirm() {
        working = true
        error   = null
        api.post("/consent/assign", { 
            domain     : domain.id,
            activities : selected.map(it => it.requirement.activity), 
            email      : email, 
            file       : fileData.value
        })
        .then(api.toJsonIf200)
        .then(result => {
            working = false
            activities = activities.map(a => {
                const agreement = result.find(it => a.requirement.activity === it.activity)
                if(agreement) {
                    return { requirement: a.requirement, agreement }
                } else {
                    return a
                }
            })
            cancel()
        })
        .catch(e => {
            working = false
            error = e
            setTimeout(() => {
                error = null
            }, 3000);
        })
    }

    $: confirmDisabled = selected.length === 0 || !fileData || !fileData.file
</script>

<Modal display={display}>
    <div slot="header" class="header">Evidência de Consentimento</div>
    <div slot="content" class="content">
        <div class="ui basic segment">
            <h3 class="ui header">Atividades</h3>
            <p>Selecione as atividades de tratamento cujo consentimento está evidenciado no documento</p>
            <div class="toggles">
                {#each activities as activity}
                    <div class="ui toggle checkbox" class:disabled={working || activity.agreement}>
                        <input  type="checkbox" 
                                value={activity}
                                disabled={activity.agreement} 
                                bind:group={selected}>
                        <label>{activity.requirement.title}</label>
                    </div>
                {/each}
            </div>
        </div>
        <div class="ui basic segment">
            <h3 class="ui header">Arquivo</h3>
            <p>Forneça o arquivo com o documento que comprova o consentimento dos titular para as atividades selecionadas acima</p>
            <FileUpload on:change={fileReady}></FileUpload>
        </div>
    </div>
    <div slot="actions" class="actions">
        {#if error}   <span class="ui red label"             transition:fade>Erro</span> {/if}
        {#if working} <i class="notched circle loading icon" transition:fade></i>        {/if}
        <button class="ui button"      class:disabled={working}                    on:click={cancel}>Cancel</button>
        <button class="ui blue button" class:disabled={working || confirmDisabled} on:click={confirm}>Confirmar</button>
    </div>            
</Modal>


<style>

    .toggles {
        display: flex;
        flex-direction: column;
        margin: 1em;
    }
    
    .toggles .checkbox {
        margin: 1em 0;
    }

</style>
